import { withPermission } from "app/auth/components/withPermission";
import History from "../screens/History";
import NoAccessScreen from "@shared/components/NoAccessScreen";
import TeleassistanceDetail from "../screens/TeleassistanceDetailScreen";

export const HistoryScreen = withPermission(
  History,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

export const TeleassistanceDetailScreen = withPermission(
  TeleassistanceDetail,
  'noRestrictions::all',
  { Fallback: NoAccessScreen }
);

